import { titleCasePreserveAcronyms } from "@/lib/string/title-case";
import { EmptyCell } from "./empty";
import type { CandidateCellRow } from "./row";

export function JobTitleCell({ row }: { row: CandidateCellRow }) {
  const title = row.jobTitle?.trim();
  if (!title) return <EmptyCell />;
  return (
    <span className="block truncate whitespace-nowrap text-sm text-heading">
      {titleCasePreserveAcronyms(title)}
    </span>
  );
}
